// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ae1cffcd","963":"47d5adc3"}[chunkId] + ".chunk.js";
};